import { X, SquareArrowOutUpRight } from "lucide-react";

import React, { useState, useEffect } from "react";

import { Button } from "@/design-system/components/Button/Button";

interface BannerProps {
  title?: React.ReactNode | string;
  buttonText?: string;
}

export const AnnouncementBanner = ({ title, buttonText }: BannerProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const dismissedForever = localStorage.getItem("bannerDismissedForever");
    if (!dismissedForever) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem("bannerDismissedForever", "true");
  };

  if (!title || !isVisible) {
    return null;
  }

  return (
    <div className="bg-surface-subtle flex w-full justify-center p-4 pr-6">
      <div className="flex items-center gap-4 text-base">
        <span>{title}</span>

        {buttonText && (
          <Button
            variant="outline"
            trailingIcon={<SquareArrowOutUpRight size={20} />}
          >
            {buttonText}
          </Button>
        )}
      </div>
      <button
        onClick={handleDismiss}
        className="hover:bg-opacity-10 text-textDefault focus:outline-interactive-selected absolute top-1 right-1 flex h-5 w-5 rounded-full hover:cursor-pointer focus:outline-2"
        aria-label="Close alert"
      >
        <X />
      </button>
    </div>
  );
};
